module.exports = __webpack_public_path__ + "static/media/clue-info-screen.719f6d66.png";